import { t } from 'i18next';
import React from 'react';

import { PrimaryButtonS } from "../../common";

const SaveBtn = ({ loading, onClick, disabled, ...rest }) =>
  <PrimaryButtonS type="submit" padding='11px 65px' {...{ loading, disabled, onClick, ...rest }}>
    {t('companyEdit.saveBtn')}
  </PrimaryButtonS>

export default SaveBtn;
